<template>
	<v-card outlined>
		<v-tabs v-model="tab" show-arrows data-tour="products-tabs">
			<v-tab v-for="s in stati" :key="s.value">
				{{ s.testo }}
				<v-chip x-small class="ml-2">{{ conteggio(s.value) }}</v-chip>
			</v-tab>
		</v-tabs>

		<v-card-text class="pb-0" data-tour="products-search">
			<v-row dense>
				<v-col cols="12" md="4">
					<v-text-field v-model="cerca" label="Cerca per nome, SKU o EAN" outlined dense hide-details append-icon="mdi-magnify" @keyup.enter="cercaOra" @click:append="cercaOra"></v-text-field>
				</v-col>
				<v-col cols="12" md="3">
					<v-switch :input-value="settings.filters.duplicates" color="primary" dense hide-details label="Solo già presenti in catalogo" class="mt-1" @change="v => $emit('filter', { duplicates: !!v })"></v-switch>
				</v-col>
				<!-- senza selezione multipla: si importano in blocco i prodotti che la lista sta mostrando -->
				<v-col v-if="importabili && totale > 0" cols="12" md="5" class="d-flex align-center justify-md-end">
					<v-btn outlined color="primary" class="mr-2" data-tour="rewrite-filtered" :loading="avvioRiscrittura" @click="confermaRiscrittura = true">
						<v-icon left>mdi-text-box-edit-outline</v-icon>
						Riscrivi tutti ({{ totale }})
					</v-btn>
					<v-btn depressed color="primary" data-tour="approve-filtered" @click="$emit('approve-filtered', totale)">
						<v-icon left>mdi-database-import-outline</v-icon>
						Importa tutti ({{ totale }})
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>

		<v-data-table
			data-tour="products-table"
			:headers="headers"
			:items="righe"
			:options="settings.options"
			:server-items-length="totale"
			:loading="caricamento"
			must-sort
			item-key="_id"
			@update:options="$emit('options', $event)"
			:footer-props="{ 'items-per-page-options': perPageOptions }"
			class="text-left"
		>
			<!-- tre puntini: tutte le azioni della riga (niente selezione multipla) -->
			<template v-slot:[`item.menu`]="{ item }">
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
							<v-icon dark>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item link @click="$emit('open', item._id)">
							<v-list-item-title class="size9">{{ modificabile(item) ? 'Apri e modifica' : 'Apri il dettaglio' }}</v-list-item-title>
						</v-list-item>
						<template v-if="daValutare(item)">
							<v-list-item link @click="$emit('approve', [item._id])">
								<v-list-item-title class="size9">Approva e importa</v-list-item-title>
							</v-list-item>
							<v-list-item link @click="azione('rejectProducts', 'Prodotto scartato', item)">
								<v-list-item-title class="size9">Scarta</v-list-item-title>
							</v-list-item>
							<v-list-item link @click="elaboraTesti('translateProducts', 'Traduzione avviata: con il modello locale serve circa un minuto', item)">
								<v-list-item-title class="size9">Traduci</v-list-item-title>
							</v-list-item>
							<v-list-item link @click="elaboraTesti('rewriteProducts', 'Riscrittura avviata: con il modello locale serve circa un minuto', item)">
								<v-list-item-title class="size9">Riscrivi testi</v-list-item-title>
							</v-list-item>
						</template>
						<v-list-item v-if="item.status === 'rejected'" link @click="azione('restoreProducts', 'Prodotto ripristinato', item)">
							<v-list-item-title class="size9">Ripristina</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="riscansionabile(item)" link title="Riscarica dal sito solo questo prodotto, senza rifare la scansione completa" @click="chiediRiscansione(item)">
							<v-list-item-title class="size9">Riscansiona</v-list-item-title>
						</v-list-item>
						<v-list-item v-if="item.importedItem" link @click="$emit('catalog', item.importedItem)">
							<v-list-item-title class="size9">Apri nel catalogo</v-list-item-title>
						</v-list-item>
						<v-list-item v-else-if="item.matchItem" link @click="$emit('catalog', item.matchItem)">
							<v-list-item-title class="size9">Apri il prodotto già in catalogo</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<template v-slot:[`item.image`]="{ item }">
				<v-img v-if="immagine(item)" :src="immagine(item)" max-width="48" max-height="48" contain class="my-1"></v-img>
			</template>
			<template v-slot:[`item.name`]="{ item }">
				<template v-if="item.translated && item.translated.status === 'done' && item.translated.name">
					<div>{{ item.translated.name }}</div>
					<div class="caption grey--text">{{ item.data && item.data.name }}</div>
				</template>
				<div v-else>{{ item.data && item.data.name }}</div>
				<a class="caption" :href="item.sourceUrl" target="_blank" rel="noopener noreferrer" @click.stop>pagina originale</a>
			</template>
			<template v-slot:[`item.codici`]="{ item }">
				<div class="caption">SKU {{ (item.data && item.data.sku) || '—' }}</div>
				<div class="caption">EAN {{ (item.data && item.data.ean) || '—' }}</div>
			</template>
			<template v-slot:[`item.price`]="{ item }">{{ prezzo(item) }}</template>
			<template v-slot:[`item.varianti`]="{ item }">{{ ((item.data && item.data.variants) || []).length || 1 }}</template>
			<template v-slot:[`item.flag`]="{ item }">
				<v-chip v-if="daCompletare(item)" x-small color="warning" class="mr-1 mb-1" :title="daCompletare(item)">Da completare</v-chip>
				<v-chip v-if="statoTraduzione(item)" x-small :color="statoTraduzione(item).colore" :outlined="statoTraduzione(item).outlined" class="mr-1 mb-1">{{ statoTraduzione(item).testo }}</v-chip>
				<v-chip v-if="item.matchItem && item.status !== 'imported'" x-small color="warning" outlined class="mr-1 mb-1">Già in catalogo</v-chip>
				<v-chip v-if="item.status === 'updated'" x-small color="primary" outlined class="mr-1 mb-1">Cambiato sul sito</v-chip>
				<v-chip v-if="item.changedAfterImport" x-small color="primary" outlined class="mr-1 mb-1">Cambiato dopo l'import</v-chip>
				<v-chip v-if="item.rewritten && item.rewritten.status" x-small :color="coloreRiscrittura(item)" outlined class="mr-1 mb-1" :title="item.rewritten.error || ''">
					{{ testoRiscrittura(item) }}
				</v-chip>
				<v-chip v-if="punteggioSeo(item) !== null" x-small :color="punteggioSeo(item) === 100 ? 'success' : 'warning'" outlined class="mr-1 mb-1" title="Punteggio dell'analisi SEO">SEO {{ punteggioSeo(item) }}</v-chip>
				<div v-if="item.error" class="caption error--text">{{ testoErrore(item.error) }}</div>
			</template>
		</v-data-table>

		<!-- conferma breve: la riscansione sovrascrive i dati estratti con quelli del sito -->
		<v-dialog v-model="conferma.aperta" max-width="460">
			<v-card>
				<v-card-title>Riscansionare il prodotto?</v-card-title>
				<v-card-text class="text-left">
					«{{ conferma.nome }}» viene riscaricato dal sito della marca con le regole attive: i dati estratti (testi, codici, prezzo, immagini) vengono sostituiti con quelli trovati ora sul sito.
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="conferma.aperta = false">Annulla</v-btn>
					<v-btn color="primary" depressed @click="riscansiona">Riscansiona</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="confermaRiscrittura" max-width="520">
			<v-card>
				<v-card-title>Riscrivere {{ totale }} {{ totale === 1 ? 'prodotto' : 'prodotti' }}?</v-card-title>
				<v-card-text class="text-left">
					<p>Titolo, descrizione, parola chiave, titolo e descrizione per Google vengono riscritti con il modello locale, un prodotto alla volta, e usati all'importazione. Le tabelle restano come sono.</p>
					<p>Quelli già riscritti non si rifanno, così non perdi le correzioni fatte a mano. Il modello gira su questo PC: servono circa 30 secondi a prodotto, con la GPU libera. Puoi annullare quando vuoi dal pannello in alto.</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="confermaRiscrittura = false">Annulla</v-btn>
					<v-btn color="primary" depressed @click="riscriviTutti">Riscrivi tutti</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { STATI_PRODOTTO, testoErrore } from './testi';

export default {
	name: 'BrandImportProductsTable',
	props: {
		brandId: { type: String, required: true },
		refreshKey: { type: Number, default: 0 },
		// stato della lista (scheda, ricerca, filtri, pagina) tenuto nell'URL dalla pagina (listRouteState):
		// qui si leggono e i cambi si segnalano (filter, options, search): caricamento e ritorno a pagina 1 li fa il mixin della pagina
		settings: { type: Object, required: true },
		perPageOptions: { type: Array, default: () => [25, 50, 100] },
	},
	data() {
		return {
			confermaRiscrittura: false,
			avvioRiscrittura: false,
			stati: STATI_PRODOTTO,
			cerca: this.settings.search || '',
			righe: [],
			totale: 0,
			conteggi: {},
			linguaNegozio: 'it',
			caricamento: false,
			conferma: { aperta: false, nome: '', item: null },
			headers: [
				{ text: '', value: 'menu', sortable: false, width: 50 },
				{ text: '', value: 'image', sortable: false, width: 60 },
				{ text: 'Prodotto', value: 'name', sortable: false },
				{ text: 'Codici', value: 'codici', sortable: false },
				{ text: 'Prezzo', value: 'price', sortable: false },
				{ text: 'Varianti', value: 'varianti', sortable: false },
				{ text: '', value: 'flag', sortable: false },
			],
		};
	},
	computed: {
		// la scheda corrente contiene prodotti che si possono ancora importare
		importabili() {
			const stati = String(this.settings.filters.status || '').split(',');
			return stati.some(st => ['new', 'updated', 'error'].includes(st));
		},
		// scheda attiva = filtro status della lista
		tab: {
			get() {
				return Math.max(
					0,
					this.stati.findIndex(s => s.value === this.settings.filters.status),
				);
			},
			set(i) {
				const stato = this.stati[i] && this.stati[i].value;
				if (stato && stato !== this.settings.filters.status) this.$emit('filter', { status: stato });
			},
		},
	},
	async created() {
		const res = await this.$store.dispatch('brandimport/fetchOptions');
		if (!res.error && res.data) this.linguaNegozio = res.data.lang || 'it';
	},
	watch: {
		refreshKey() {
			this.carica();
		},
		// ricerca cambiata dall'URL (es. voce di menu): il campo si riallinea
		'settings.search'(value) {
			this.cerca = value || '';
		},
	},
	methods: {
		testoErrore,
		conteggio(valore) {
			return valore.split(',').reduce((n, s) => n + (this.conteggi[s] || 0), 0);
		},
		// Siti vetrina: SKU/EAN e prezzo non ci sono sulla pagina e li inserisce il merchant
		daCompletare(item) {
			if (item.status === 'imported') return '';
			const d = item.data || {};
			const mancano = [];
			if (!d.sku && !d.ean) mancano.push('SKU/EAN');
			if (d.price == null) mancano.push('prezzo');
			return mancano.length ? `Mancano: ${mancano.join(', ')}` : '';
		},
		immagine(item) {
			return item.data && item.data.images && item.data.images[0];
		},
		prezzo(item) {
			const p = item.data && item.data.price;
			return p != null ? `${Number(p).toFixed(2)} ${item.data.currency || 'EUR'}` : '—';
		},
		daValutare(item) {
			return ['new', 'updated', 'error'].includes(item.status);
		},
		modificabile(item) {
			return !['imported', 'importing', 'approved'].includes(item.status);
		},
		riscansionabile(item) {
			return ['new', 'updated', 'rejected', 'error'].includes(item.status);
		},
		cercaOra() {
			this.$emit('search', (this.cerca || '').length >= 3 ? this.cerca : '');
		},
		// chiamato dalla pagina (fetch del mixin listRouteState)
		async carica() {
			this.caricamento = true;
			const { filters, options, search } = this.settings;
			const res = await this.$store.dispatch('brandimport/fetchProducts', {
				// dai filtri e non dalla prop: al cambio marca il mixin ricarica prima che la prop si aggiorni
				brand: filters.brand || this.brandId,
				status: filters.status,
				q: search || undefined,
				duplicates: filters.duplicates || undefined,
				page: options.page,
				itemsPerPage: options.itemsPerPage,
			});
			this.caricamento = false;
			if (res.error) {
				this.$emit('error', testoErrore(res.error));
				return;
			}
			this.righe = res.data.items;
			this.totale = res.data.total;
			this.conteggi = res.data.counts || {};
		},
		async azione(nome, messaggio, item) {
			const res = await this.$store.dispatch(`brandimport/${nome}`, [item._id]);
			if (res.error) {
				this.$emit('error', testoErrore(res.error));
				return;
			}
			this.$emit('info', messaggio);
			this.carica();
		},
		async riscriviTutti() {
			this.confermaRiscrittura = false;
			this.avvioRiscrittura = true;
			const { status, duplicates } = this.settings.filters;
			const res = await this.$store.dispatch('brandimport/rewriteFiltered', { brandId: this.brandId, filter: { status, q: this.settings.search || undefined, duplicates: duplicates || undefined } });
			this.avvioRiscrittura = false;
			if (res.error) {
				this.$emit('error', testoErrore(res.error));
				return;
			}
			if (res.data) this.$emit('job', res.data);
			const parti = [res.avviati ? `Riscrittura avviata per ${res.avviati} prodotti` : 'Niente da riscrivere'];
			if (res.giaPronti) parti.push(`${res.giaPronti} già riscritti ora in uso`);
			if (res.restanti) parti.push(`per i restanti ${res.restanti} ripeti al termine`);
			this.$emit('info', parti.join(': ').replace(': per', ', per'));
			this.carica();
		},
		// Job del worker sul prodotto: traduzione, riscrittura (modello locale) e riscansione
		async elaboraTesti(azione, messaggio, item) {
			const res = await this.$store.dispatch(`brandimport/${azione}`, { brandId: this.brandId, ids: [item._id] });
			if (res.error) {
				this.$emit('error', testoErrore(res.error));
				return;
			}
			this.$emit('job', res.data);
			this.$emit('info', messaggio);
			this.carica();
		},
		chiediRiscansione(item) {
			const d = item.data || {};
			this.conferma = { aperta: true, nome: (item.translated && item.translated.name) || d.name || item.sourceUrl, item };
		},
		riscansiona() {
			const item = this.conferma.item;
			this.conferma = { aperta: false, nome: '', item: null };
			if (item) this.elaboraTesti('rescanProducts', 'Riscansione avviata: aggiorno solo questo prodotto', item);
		},
		testoRiscrittura(item) {
			const r = item.rewritten;
			if (r.status === 'error') return 'Riscrittura non riuscita';
			if (r.status !== 'done') return 'Riscrittura in corso';
			if (!(r.version >= 2)) return 'Riscrittura da rifare';
			return item.useRewritten ? 'Testi riscritti in uso' : 'Riscrittura pronta';
		},
		coloreRiscrittura(item) {
			const r = item.rewritten;
			if (r.status === 'error') return 'error';
			if (r.status !== 'done') return 'grey';
			return r.version >= 2 ? 'success' : 'warning';
		},
		// dopo l'import vale quello calcolato in catalogo, prima quello dei testi
		punteggioSeo(item) {
			if (item.seoImport && item.seoImport.score !== undefined) return item.seoImport.score;
			const seo = item.rewritten && item.rewritten.status === 'done' && item.rewritten.seo;
			return seo && seo.score !== undefined ? seo.score : null;
		},
		statoTraduzione(item) {
			const t = item.translated && item.translated.status;
			if (t === 'done') return { testo: 'Tradotto', colore: 'success', outlined: true };
			if (t === 'queued' || t === 'running') return { testo: 'Traduzione in corso', colore: 'grey', outlined: true };
			if (item.lang && item.lang !== this.linguaNegozio && item.status !== 'imported') return { testo: `Da tradurre (${item.lang})`, colore: 'warning', outlined: false };
			return null;
		},
	},
};
</script>
